<script setup lang="ts">
import { ElCheckbox } from 'element-plus';
import type { CheckboxValueType } from 'element-plus';

defineProps<{
  modelValue: boolean
  label: string
  inputName: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', data: boolean): void
}>()

</script>

<template>
  <ElCheckbox
    :id="inputName"
    :name="inputName"
    :model-value="modelValue"
    :label="label"
    @update:model-value="(value: CheckboxValueType) => emit('update:modelValue', Boolean(value))"
  />
</template>
